import ScrollReveal from '@/components/ScrollReveal';

export default function CtaBanner() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="py-20 sm:py-24"
      style={{
        background: 'linear-gradient(135deg, #0f2240 0%, #0a1628 50%, #0f2240 100%)',
      }}
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <ScrollReveal>
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl text-white mb-5">
            Ready to Access the Capital Markets?
          </h2>
          <p className="font-inter text-base sm:text-lg leading-relaxed mb-10" style={{ color: '#9ca3af' }}>
            Whether you are a first-time issuer or a seasoned borrower, our team is prepared to structure the optimal debt instrument for your capital requirements.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="#contact"
              onClick={(e) => scrollTo(e, '#contact')}
              className="font-semibold px-7 py-3.5 rounded font-inter"
              style={{ backgroundColor: '#c9a84c', color: '#060f1d', transition: 'background-color 200ms' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#dfc26e'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#c9a84c'}
              data-testid="cta-banner-consultation"
            >
              Request a Confidential Consultation
            </a>
            <a
              href="mailto:info@alcbond.com"
              className="font-semibold px-7 py-3.5 rounded font-inter"
              style={{
                border: '1px solid rgba(201,168,76,0.5)',
                color: '#c9a84c',
                transition: 'background-color 200ms',
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(201,168,76,0.1)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              data-testid="cta-banner-email"
            >
              Email Our Team
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
